"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var useScrollPosition_1 = require("./hooks/useScrollPosition");

var react_scroll_1 = require("react-scroll");

var HamburgerButton_1 = require("./HamburgerButton");

var polished_1 = require("polished"); // Context is made up of two things
// Provider - Single as close to top level as possible
// Consumer - Multiple have multiple consumers


exports.HeaderContext = react_1.createContext({
  isMenuOpen: undefined,
  setMenuOpen: undefined
});

exports.HeaderProvider = function (_a) {
  var children = _a.children,
      menuOpen = _a.menuOpen;

  var _b = react_1.useState(menuOpen),
      isMenuOpen = _b[0],
      setMenuOpen = _b[1];

  return react_1.default.createElement(exports.HeaderContext.Provider, {
    value: {
      isMenuOpen: isMenuOpen,
      setMenuOpen: setMenuOpen
    }
  }, children);
};

var Menu = styled_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  transform: ", ";\n  opacity: ", ";\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: ", ";\n  flex-direction: column;\n  justify-content: center;\n  transition: all 200ms;\n  padding: ", "px;\n  list-style: none;\n  margin: 0;\n\n  @media (min-width: ", "px) {\n    background: transparent;\n    position: static;\n    flex-direction: row;\n    align-items: center;\n    opacity: 1;\n    padding: 0;\n    transform: unset;\n  }\n"], ["\n  display: flex;\n  transform: ", ";\n  opacity: ", ";\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: ", ";\n  flex-direction: column;\n  justify-content: center;\n  transition: all 200ms;\n  padding: ", "px;\n  list-style: none;\n  margin: 0;\n\n  @media (min-width: ", "px) {\n    background: transparent;\n    position: static;\n    flex-direction: row;\n    align-items: center;\n    opacity: 1;\n    padding: 0;\n    transform: unset;\n  }\n"])), function (_a) {
  var isOpen = _a.isOpen;
  return isOpen ? 'unset' : 'translateX(100%)';
}, function (_a) {
  var isOpen = _a.isOpen;
  return isOpen ? 1 : 0;
}, function (_a) {
  var theme = _a.theme;
  return theme.header.background;
}, function (_a) {
  var theme = _a.theme;
  return theme.card.paddingHorizontal;
}, function (_a) {
  var theme = _a.theme;
  return theme.thresholds.md;
});
var StyledHeader = styled_1.default.header(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  color: ", ";\n  padding: 5px 0;\n  z-index: 9;\n  height: ", ";\n  box-shadow: ", ";\n  transform: ", ";\n  transition: all 100ms, transform 200ms;\n"], ["\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  color: ", ";\n  padding: 5px 0;\n  z-index: 9;\n  height: ", ";\n  box-shadow: ", ";\n  transform: ", ";\n  transition: all 100ms, transform 200ms;\n"])), function (_a) {
  var isTop = _a.isTop,
      theme = _a.theme;
  return isTop ? theme.header.backgroundTop : theme.header.background;
}, function (_a) {
  var theme = _a.theme;
  return theme.header.color;
}, function (_a) {
  var height = _a.height;
  return height || 'auto';
}, function (_a) {
  var isTop = _a.isTop,
      theme = _a.theme;
  return isTop ? 'none' : theme.header.boxShadow;
}, function (_a) {
  var isOpen = _a.isOpen;
  return isOpen ? 'none' : 'translateY(-100%)';
});

exports.Header = function (_a) {
  var alwaysOpen = _a.alwaysOpen,
      neverHide = _a.neverHide,
      children = _a.children,
      height = _a.height,
      props = __rest(_a, ["alwaysOpen", "neverHide", "children", "height"]);

  var _b = react_1.useState(true),
      isHeaderOpen = _b[0],
      setHeaderOpen = _b[1];

  var _c = react_1.useState(true),
      isTop = _c[0],
      setTop = _c[1];

  useScrollPosition_1.useScrollPosition(function (_a) {
    var previousPosition = _a.previousPosition,
        currentPosition = _a.currentPosition;
    var newOpen = currentPosition.y > previousPosition.y;

    if (newOpen !== isHeaderOpen) {
      setHeaderOpen(newOpen);
    }

    var newTop = currentPosition.y > -25;

    if (newTop !== isTop) {
      setTop(newTop);
    }

    var isOpen = currentPosition.y > -50;

    if (isOpen) {
      setHeaderOpen(true);
    }
  }, [isHeaderOpen]);
  react_1.useEffect(function () {
    if (alwaysOpen) {
      return react_scroll_1.Events.scrollEvent.register('end', function () {
        return setTimeout(function () {
          return setHeaderOpen(true);
        }, 100);
      });
    }
  }, []);
  return react_1.default.createElement(exports.HeaderContext.Consumer, null, function (_a) {
    var isMenuOpen = _a.isMenuOpen;
    return react_1.default.createElement(StyledHeader, __assign({}, props, {
      isOpen: isHeaderOpen || isMenuOpen || alwaysOpen || isTop || neverHide || false,
      isTop: isTop && !alwaysOpen,
      height: height
    }), children);
  });
};

exports.HeaderMenu = function (_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return react_1.default.createElement(exports.HeaderContext.Consumer, null, function (_a) {
    var isMenuOpen = _a.isMenuOpen,
        setMenuOpen = _a.setMenuOpen;
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Menu, __assign({}, props, {
      isOpen: isMenuOpen !== null && isMenuOpen !== void 0 ? isMenuOpen : false
    }), children), react_1.default.createElement(HamburgerButton_1.HamburgerButton, {
      isOpen: isMenuOpen,
      onToggle: function onToggle() {
        var _a;

        return (_a = setMenuOpen) === null || _a === void 0 ? void 0 : _a(function (prev) {
          return !prev;
        });
      }
    }));
  });
};

exports.HeaderItem = styled_1.default.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0 0 10px;\n\n  a,\n  button {\n    display: block;\n    font-size: 16px;\n    color: ", ";\n    text-decoration: none;\n    padding: 10px 20px 6px;\n    border: 0;\n    border-left: 4px solid\n      ", ";\n    transition: all 300ms;\n  }\n\n  a:hover,\n  button:hover {\n    border-left-color: ", ";\n  }\n\n  a.active,\n  button:hover {\n    border-left-color: ", ";\n  }\n\n  @media (min-width: ", "px) {\n    margin: 0 10px 0 0;\n\n    a,\n    button {\n      border-left: 0;\n      border-bottom: 2px solid\n        ", ";\n    }\n\n    a.active,\n    button:hover {\n      border-bottom-color: ", ";\n    }\n    a:hover,\n    button:hover {\n      border-bottom-color: ", ";\n    }\n  }\n"], ["\n  margin: 0 0 10px;\n\n  a,\n  button {\n    display: block;\n    font-size: 16px;\n    color: ", ";\n    text-decoration: none;\n    padding: 10px 20px 6px;\n    border: 0;\n    border-left: 4px solid\n      ", ";\n    transition: all 300ms;\n  }\n\n  a:hover,\n  button:hover {\n    border-left-color: ", ";\n  }\n\n  a.active,\n  button:hover {\n    border-left-color: ", ";\n  }\n\n  @media (min-width: ", "px) {\n    margin: 0 10px 0 0;\n\n    a,\n    button {\n      border-left: 0;\n      border-bottom: 2px solid\n        ", ";\n    }\n\n    a.active,\n    button:hover {\n      border-bottom-color: ", ";\n    }\n    a:hover,\n    button:hover {\n      border-bottom-color: ", ";\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.header.color;
}, function (_a) {
  var theme = _a.theme,
      isActive = _a.isActive;
  return isActive ? theme.header.color : 'transparent';
}, function (_a) {
  var theme = _a.theme;
  return polished_1.transparentize('0.8', theme.colors.primary.color);
}, function (_a) {
  var theme = _a.theme;
  return theme.header.color;
}, function (_a) {
  var theme = _a.theme;
  return theme.thresholds.md;
}, function (_a) {
  var theme = _a.theme,
      isActive = _a.isActive;
  return isActive ? theme.header.color : 'transparent';
}, function (_a) {
  var theme = _a.theme;
  return polished_1.transparentize('0.8', theme.header.color);
}, function (_a) {
  var theme = _a.theme;
  return theme.header.color;
});
var templateObject_1, templateObject_2, templateObject_3;